import type ClientAttachmentId from '../schema/ClientAttachmentId';

export default function isClientAttachmentIdEqual(
    lhs: ClientAttachmentId | null | undefined,
    rhs: ClientAttachmentId | null | undefined
): boolean {
    return lhs === rhs || (lhs != null && rhs != null && lhs.Id === rhs.Id);
}
